import React from 'react'
import { Link } from 'gatsby'

import fl_logo from '../img/fl_logo.svg'
import elsi_logo from '../img/elsi_logo.jpg'
import efadp_logo2 from '../img/efadp_logo_color_02.jpg'
import facebook from '../img/social/facebook.svg'
import instagram from '../img/social/instagram.svg'
import twitter from '../img/social/twitter.svg'
import vimeo from '../img/social/vimeo.svg'

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content logos has-background-white has-text-centered">
          <a href="https://firstlogic.co.jp" target="_blank">
            <img
              src={fl_logo}
              alt="Firstlogic"
              className="footer__logoFl"
            />
          </a>
          <a href="http://www.elsi.jp/" target="_blank">
            <img
              src={elsi_logo}
              alt="ELSI"
              className="footer__logoELSI"
            />
          </a>
          <img
            src={efadp_logo2}
            alt="EFADP"
            className="footer__logoEFADP"
          />
        </div>
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container has-background-black has-text-white-ter">
            <div className="columns">
              <div className="column is-4">
                <section className="menu">
                  <ul className="menu-list">
                    <li>
                      <Link to="/" className="navbar-item">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/about">
                        About
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/profile">
                        Profile
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/research">
                        Research
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/education">
                        Education
                      </Link>
                    </li>
                    <li>
                      <a
                        className="navbar-item"
                        href="/admin/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Admin
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4">
                <section>
                  <ul className="menu-list">
                    <li>
                      <Link className="navbar-item" to="/outreach">
                        Outreach
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/conference">
                        Conference
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/media">
                        Media
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/story">
                        Story
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/blog">
                        Blog
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/news">
                        AstroNews
                      </Link>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4 social">
                <a title="facebook" href="https://facebook.com">
                  <img
                    src={facebook}
                    alt="Facebook"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
                <a title="twitter" href="https://twitter.com">
                  <img
                    className="fas fa-lg"
                    src={twitter}
                    alt="Twitter"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
                <a title="instagram" href="https://instagram.com">
                  <img
                    src={instagram}
                    alt="Instagram"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
                <a title="vimeo" href="https://vimeo.com">
                  <img
                    src={vimeo}
                    alt="Vimeo"
                    style={{ width: '1em', height: '1em' }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}

export default Footer
